import React, { useCallback } from 'react'
import { clsx } from 'clsx'

import { Field, FieldBaseProps } from '../_internal/Field/Field'
import { Icon, IconName } from '../Icon'
import { Stack } from '../Stack/Stack'

import * as styles from './Dropdown.css'

type Props = {
    value?: string
    defaultValue?: string
    options: { label: string; value: string }[]
    onChange?: (value: string) => void
    icon?: IconName
} & FieldBaseProps

export type DropdownProps = Props

export const Dropdown = (props: Props) => {
    const {
        value,
        defaultValue,
        options,
        onChange: delegatedOnChange,
        icon = 'arrowDown',
        ...fieldProps
    } = props

    const onChange = useCallback(
        (e: React.FormEvent) => {
            const selectEvent = e as React.FormEvent<HTMLSelectElement>
            delegatedOnChange?.(selectEvent.currentTarget.value)
        },
        [delegatedOnChange],
    )

    return (
        <Field {...fieldProps} background={fieldProps.background ?? 'level2'} paddingX="none">
            {(overlays, { className, ...inputProps }) => (
                <>
                    <Stack
                        horizontal
                        paddingX
                        as="select"
                        cursor="pointer"
                        className={clsx(className, styles.dropdown)}
                        rounded="sm"
                        onChange={onChange}
                        {...inputProps}
                        {...(value !== undefined ? { value } : { defaultValue })}
                    >
                        {options.map((o) => (
                            <option key={o.value} value={o.value}>
                                {String(o.label)}
                            </option>
                        ))}
                    </Stack>
                    {overlays}
                    <Icon
                        type={icon}
                        size="square_xs"
                        pointerEvents="none"
                        position="absolute"
                        right="sm"
                    />
                </>
            )}
        </Field>
    )
}
